import {
  AnyAction,
  ListenerEffectAPI,
  PayloadAction,
  ThunkDispatch,
} from '@reduxjs/toolkit';

import { getFirmwaresWithPagination } from '../../../shared/thunks/get-firmwares-with-pagination/get-firmwares-with-pagination.thunk';
import { AppRootState } from '../../../store/models/app-state.model';
import { FiltersPayloadModel } from '../../shared/models/filters-payload.model';
import { FirmwareFilters } from '../models/firmware-filters.model';
import { FirmwareHeaderAndPaginationFilters } from '../models/firmware-header-and-pagination-filters.model';
import { FirmwareFilterListenerEffectModel } from './firmware-filter-listener-effect.model';

export const FirmwarePaginationListenerEffect: FirmwareFilterListenerEffectModel =
  (
    action: AnyAction,
    api: ListenerEffectAPI<
      AppRootState,
      ThunkDispatch<AppRootState, undefined, AnyAction>,
      unknown
    >
  ): void => {
    const currentAction = action as PayloadAction<
      FiltersPayloadModel<FirmwareFilters>
    >;
    if (currentAction.payload?.property !== 'name') {
      const filters: Partial<FirmwareHeaderAndPaginationFilters> =
        api.getState().firmware.filters;
      api.dispatch(getFirmwaresWithPagination(filters));
    }
  };
